// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTechnologyCameraDisabled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.146 3.146 17 5h2a3 3 0 0 1 3 3v10c0 .66-.213 1.27-.575 1.766l-1.47-1.47c.03-.093.045-.193.045-.296V8a1 1 0 0 0-1-1h-2.828l-2-2H9.828L8.244 6.585 6.659 5H7l1.854-1.854A.5.5 0 0 1 9.207 3h5.586a.5.5 0 0 1 .353.146zM18.537 19l1.723 1.723-.002.001.805.805a.25.25 0 0 1 0 .354l-.354.353a.25.25 0 0 1-.353 0l-1.239-1.238A3.26 3.26 0 0 1 19 21H5a3 3 0 0 1-3-3V8c0-1.116.61-2.09 1.513-2.606l-.95-.95a.25.25 0 0 1 0-.353l.354-.354a.25.25 0 0 1 .354 0l1.294 1.294h.003L6.538 7h-.004l2.385 2.385.002-.002 1.422 1.422-.002.002 3.852 3.852.002-.002 1.422 1.422-.002.002L18.534 19zm-1.418 0-2.23-2.23a4.75 4.75 0 0 1-6.66-6.66L5.12 7H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1zm-7.454-7.454a2.75 2.75 0 0 0 3.789 3.789zM12 10.25l-.09.001-1.666-1.666a4.75 4.75 0 0 1 6.171 6.171l-1.666-1.666.001-.09A2.75 2.75 0 0 0 12 10.25z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTechnologyCameraDisabled;
